module.exports = __webpack_public_path__ + "static/media/technology-icon-organise.2dee27e1.png";